import React from "react";

import useFetch from "commons/hooks/useFetch";

import { BlockEnum } from "types/enums";

import packageInfo from "../../package.json";

export type ConfigContextType = {
    environment: string;
    features: Array<string>;
    disabledBlocks: Array<BlockEnum>;
    logoUrl: string | null;
    backofficeName: string;
};

export const ConfigContext = React.createContext<ConfigContextType>({
    environment: "",
    features: [],
    disabledBlocks: [],
    logoUrl: "",
    backofficeName: "",
});

export const useConfigContext = () => React.useContext(ConfigContext);

type PropsType = {
    children: JSX.Element;
};

export const ConfigContextProvider = (props: PropsType) => {
    const [config, setConfig] = React.useState<ConfigContextType | undefined>(undefined);

    const { get } = useFetch();

    React.useEffect(() => {
        const [apiCall, abortController] = get<undefined, { v: string }, ConfigContextType>({
            url: process.env.PUBLIC_URL + "/config.json",
            queryParams: { v: packageInfo.version },
        });

        apiCall
            .then(setConfig)
            .catch((error) => console.log("FIXME - Gestire errore chiamata config", error));

        return () => abortController.abort();
    }, [get]);

    if (config === undefined) {
        return null;
    }

    return <ConfigContext.Provider value={config}>{props.children}</ConfigContext.Provider>;
};
